<template>
    <div class="main-content">
        <h4>Verify Customer Portal Users</h4>
        <p class="diagonal-lines"></p>

        <div v-if="loading">
            <div class="vh-100 d-flex justify-content-center align-items-center">
            <vue-loaders-ball-beat scale="2" color="black" />
            </div>
        </div>
        <div v-else>
            <div v-if="userUpdate" class="my-2">
                <div v-if="userUpdate.approved=='y'">
                    <success>{{ userUpdate.f_name }} {{ userUpdate.l_name }} has been authorized to access portal .</success>
                </div>
                <div v-else>
                    <success>{{ userUpdate.f_name }} {{ userUpdate.l_name }} has been archived.</success>
                </div>
            </div>
            <div class="new-user-list" v-if="newUserList.length != 0">

                <section class="new-user " v-for="(user,index) in newUserList" :key="index">
                    <form class="d-flex flex-column justify-content-start align-items-start">
                        <router-link class="user-name" :to="{ name: 'myAccount' }">
                            {{ user.f_name }} {{ user.l_name }}
                        </router-link>
                        <small><i>{{ timestampToDateTime(user.timestamp) }}</i></small>
                        <p><strong>COMPANY: </strong><span>{{ user.company }}</span></p>
                        <p><strong>TITLE: </strong><span>{{ user.title }}</span></p>
                        <p><strong>ADDRESS: </strong><span>{{ user.add1 }} {{ user.add2 }} {{ user.city }},{{ user.state }},{{ user.zip }}</span></p>
                        <p><strong>PHONE: </strong><span>{{ user.phone }}</span></p>
                        <p><strong>EMAIL: </strong><span>{{ user.email }}</span></p>
                        <p><strong>CUSTOMER BILL-TO: </strong><span>{{ user.cust_id }}</span></p>
                        <p><strong>USER ROLE: </strong><span>{{ user.user_role }}</span></p>
                        <p><strong>TEMP PASSWORD: </strong><span>{{ user.tempPassword }}</span></p>

                        <div class="mt-3">
                            <b-form-group label="ADMIN APPROVAL:" v-slot="{ ariaDescribedby }"  >
                                <b-form-radio-group
                                    v-model="user.approved"
                                    :aria-describedby="ariaDescribedby"
                                    :name="'approve_'+user.id"
                                >
                                <b-form-radio  value="y"  @change="onChangeAdminApprove(user.id,'y')">Yes</b-form-radio>
                                <b-form-radio  value="n"  @change="onChangeAdminApprove(user.id,'n')">No</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </div>

                        <button class="btn-round-red" type="submit" @click.prevent="verifyUser(user)" >SUBMIT</button>

                    </form>
                </section>


            </div>
            <div class="my-3" v-else>
                <strong>NO NEW USER HAS SIGN UP.</strong>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            loading: false,
            newUserList:[],
            userForm:[],
            showUserType:[],
            error:null,
            userUpdate:null
        };
    },

    created() {

    },
    mounted() {
        this.loading=true;
        // // get user group
        // axios.get(`/api/usergroup/`)
        // .then(response => {
        //     this.userGroup = response.data;
        // })
        // .catch(error => {
        //     this.error=error;
        // });

        axios.get(`/api/portal/user`)
        .then(response => {

            this.newUserList = response.data;
            this.newUserList = this.newUserList.map(user => ({
            ...user,
            tempPassword: this.generateTempPassword(16)
            }));

            this.newUserList = this.newUserList.map(user => ({
            ...user,
            approved: null
            }));

            // for(let i=0; i<=this.newUserList.length; i++){
            //     if (response.data[i] && response.data[i].id) {
            //         this.userForm[i] = {
            //         'userID': response.data[i].id,
            //         'custID': response.data[i].cust_id || '',
            //         'approve': ''
            //         };
            //     }
            // }
            this.loading=false;

        })
        .catch(error => {
            this.error=error;
        });

    },

    methods:{
        timestampToDateTime(timestamp) {
            const year = timestamp.substring(0, 4);
            const month = timestamp.substring(4, 6);
            const day = timestamp.substring(6, 8);
            return `${year}-${month}-${day}`;
        },
        onChangeAdminApprove(index,value){
            this.$set(this.showUserType, index, value);
        },
        onSelectedUserGroup(index,e){
            this.$set(this.userGroupSelected, index, e.target.value);
        },
        generateTempPassword(length) {
            // Generate a random temporary password of the specified length with special characters, numbers, and letters
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=';
            let tempPassword = '';
            for (let i = 0; i < length; i++) {
                tempPassword += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return tempPassword;
        },
        displaySuccessMessage(user){
          if(user.approved=='y'){
            this.userUpdate = {
                f_name: user.f_name,
                l_name: user.l_name,
                approved: 'y'
            };
          }else{
            this.userUpdate = {
                f_name: user.f_name,
                l_name: user.l_name,
                approved: 'n'
            };
          }

        },
        verifyUser(user){
            this.loading=true;

            axios.post(`/api/portal/approve`, user).then(response=>{

                //get ID of the user which was just updated
                let updatedUserID=user.id;

                //remove the approved user from the array
                this.newUserList = this.newUserList.filter(function (listUser) {
                    return parseInt(listUser.id) !== parseInt(updatedUserID);
                });

                this.displaySuccessMessage(user);

                window.scrollTo(0,0);
                this.loading=false;


            }).catch(error => {
                this.loading=false;
                console.log(error);
                this.error=error;
            });
        },
    },

}
</script>
